import { reBuildFPonClick } from '../modules/fullpage';

export default {
  init() {},
  finalize() {
    reBuildFPonClick(['summary']);
  },
};
